import React from "react";

const commitments = [
  {
    heading: "Community First",
    desc: "We build bridges between caregivers, transforming individual journeys into collective strength through shared experiences and understanding.",
    icon: (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
      />
    ),
  },
  {
    heading: "Compassion Without Judgment",
    desc: "We're dedicated to building a world that celebrates neurodiversity, transforming how society understands and supports neurodiversity families.",
    icon: (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
      />
    ),
  },
  {
    heading: "Excellence in Support",
    desc: "Every resource, tool, and piece of guidance is thoughtfully verified and curated. We continuously evolve to ensure you have access to the most reliable support when you need it.",
    icon: (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
      />
    ),
  },
  {
    heading: "Connection with Purpose",
    desc: "We believe in the power of relationships that grow from shared experiences into lifelong support systems, creating a network that feels like family.",
    icon: (
      <>
        <circle cx="12" cy="12" r="3" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
        />
      </>
    ),
  },
  {
    heading: "Whole Family Approach",
    desc: "Your family's journey is unique. Our platform is shaped by and for caregivers, ensuring every feature serves both practical needs and emotional well-being—because when caregivers thrive, families flourish.",
    span: true,
    icon: (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"
      />
    ),
  },
];

/**
 * Our Commitment — design/stitch/our-story.html bento grid
 */
const Ourcommitment = () => {
  return (
    <section className="py-14 sm:py-20 md:py-28 bg-surface-white relative text-left">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="max-w-3xl mb-10 sm:mb-16">
          <p className="font-headline text-xs font-semibold text-sky-blue tracking-widest uppercase mb-2">
            Our Commitment
          </p>
          <h2 className="font-headline font-extrabold text-2xl sm:text-3xl lg:text-4xl text-ink tracking-tight mb-3 sm:mb-4">
            Shaping Tomorrow, Together
          </h2>
          <p className="font-body text-[15px] sm:text-base md:text-lg text-muted leading-relaxed max-w-2xl">
            Our promise extends beyond building a platform—we&apos;re creating
            lasting change for neurodiversity families through meaningful action
            and unwavering support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {commitments.map((item) => (
            <article
              key={item.heading}
              className={`bg-surface-white border border-hairline rounded-brand p-6 sm:p-8 hover:shadow-brand-md transition-shadow ${
                item.span
                  ? "md:col-span-2 lg:col-span-2 bg-mist-gradient"
                  : ""
              }`}
            >
              <div className="w-12 h-12 rounded-brand bg-cloud-mist flex items-center justify-center text-spectrum-blue mb-6">
                <svg
                  fill="none"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  aria-hidden="true"
                >
                  {item.icon}
                </svg>
              </div>
              <h3 className="font-headline font-bold text-lg md:text-xl text-ink mb-3">
                {item.heading}
              </h3>
              <p
                className={`font-body text-sm md:text-base text-muted leading-relaxed ${
                  item.span ? "max-w-2xl" : ""
                }`}
              >
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ourcommitment;
